import React, { useState } from 'react'
import { Col, FlexboxGrid, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { exportAssessmentReport, searchAssessmentReport } from '../../redux/actions/assessment'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../constants/date'
import InputDateForm from '../../components/forms/input/InputDateForm'

export default function AssessmentReportUnitCompetencyWidgets({ schema: _schema, type, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(_schema.form.values || [])
  const [totalSize, setTotalSize] = useState(_schema?.resultData?.total || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState()
  const [searchData, setSearchData] = useState({})
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  console.log('formSchema', formSchema)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await searchAssessmentReport(req, type)

      // console.log('response ', response)

      if (response) {
        setData(response.values || [])
        setTotalSize(response.total || 0)

        onRefash()
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const handleExport = async () => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const file = await exportAssessmentReport(request, type)

      if (file) {
        downloadFile(
          file,
          file.name || `${formSchema.header}_${moment().format(DATE_TIME_FORMAT)}.xlsx`
        )
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const onSubmit = (data) => {
    // console.log('onSubmit:', data)

    let req = {
      pageNum: 1,
      pageSize: displayLength,
    }

    var parameters = []

    if (data) {
      formSchema?.searchForm?.forEach((e) => {
        if (!isEmpty(e.inputType)) {
          parameters.push({ key: e.name, value: data[e.name] })
        }
      })
    }

    req['parameters'] = parameters

    console.log('req : ', req)

    setPage(1)
    setRequest(req)
    handleSearch(req)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)

    let req = cloneDeep(request)

    req['pageNum'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    let req = cloneDeep(request)
    req['pageNum'] = 1
    req['pageSize'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const onChangeInput = (key, value) => {
    var data = cloneDeep(searchData)

    data[key] = value
    setSearchData(data)
  }

  const MERGE_ROWS = [null, 'ROW_NULL', 'ROW_FULL_SCORE', 'ROW_TOTAL_SCORE', 'ROW_AVG_SCORE']

  const SUMMARY_ROWS = ['ROW_FULL_SCORE_OV', 'ROW_TOTAL_SCORE_OV', 'ROW_AVG_SCORE_OV', 'ROW_LEVEL']

  const CALL_ROWS = ['ROW_FULL_SCORE', 'ROW_TOTAL_SCORE', 'ROW_AVG_SCORE']

  const isMergeRow = (row) => MERGE_ROWS.includes(row.chkRows)

  const isFirstRow = (arr, index) => index === 0 || !isMergeRow(arr[index - 1])

  const getRowSpan = (arr, index) => {
    let count = 0
    for (let i = index; i < arr.length; i++) {
      if (!isMergeRow(arr[i])) break
      count++
    }
    return count
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      <>
        <Row style={{ textAlign: 'right', marginBottom: 10 }}>
          <Col>
            <ViewButton
              icon="print"
              children="Exprot Excel"
              disabled={datas?.length < 1}
              onClick={handleExport}
            />
          </Col>
        </Row>
        <div style={{ marginBottom: 20 }}>
          <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
            {/* HEADER */}
            <tr style={{ backgroundColor: '#dfdcdc' }}>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.header_l1_01}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l1_02}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l1_03}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l1_04}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l1_05}
              </th>
            </tr>

            <tr style={{ backgroundColor: '#dfdcdc' }}>
              <th style={{ padding: 3, verticalAlign: 'top' }}>
                {formSchema?.form?.columns?.header_l2_01}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l2_02}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l2_03}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l2_04}
              </th>
              <th style={{ padding: 3, verticalAlign: 'top' }} colSpan={2}>
                {formSchema?.form?.columns?.header_l2_05}
              </th>
            </tr>

            {formSchema?.form?.values?.map((item, index, arr) => {
              const mergeRow = isMergeRow(item)
              const firstRow = isFirstRow(arr, index)
              const rowSpan = firstRow ? getRowSpan(arr, index) : 0

              /* SUMMARY ROW */
              if (SUMMARY_ROWS.includes(item.chkRows)) {
                return (
                  <tr key={index} style={{ backgroundColor: '#dfdcdc' }}>
                    <td
                      colSpan={8}
                      style={{ padding: 3, textAlign: 'right', verticalAlign: 'top' }}
                    >
                      {item.col4}
                    </td>
                    <td style={{ padding: 3, textAlign: 'right', verticalAlign: 'top' }}>
                      {item.val4}
                    </td>
                  </tr>
                )
              }

              /* NULL ROW */
              if (item.chkRows === 'ROW_NULL') {
                return (
                  <tr key={index} style={{ backgroundColor: '#9e9c9c' }}>
                    <td colSpan={9} style={{ padding: 3, verticalAlign: 'top' }}>
                      &nbsp;
                    </td>
                  </tr>
                )
              }

              const cols = [
                [item.col1, item.val1],
                [item.col2, item.val2],
                [item.col3, item.val3],
                [item.col4, item.val4],
              ]

              return (
                <tr key={index}>
                  {mergeRow && firstRow && (
                    <td
                      rowSpan={rowSpan}
                      style={{
                        padding: 3,
                        backgroundColor: '#dfdcdc',
                        verticalAlign: 'top',
                      }}
                    >
                      {item.title}
                    </td>
                  )}

                  {!mergeRow && (
                    <td style={{ padding: 3, backgroundColor: '#dfdcdc', verticalAlign: 'top' }}>
                      {item.title}
                    </td>
                  )}

                  {cols.map(([col, val], i) => {
                    const isAvg = item.chkRows === 'ROW_AVG_SCORE'

                    if (CALL_ROWS.includes(item.chkRows)) {
                      return (
                        <React.Fragment key={i}>
                          <td
                            style={{ padding: 3, backgroundColor: '#dfdcdc', verticalAlign: 'top' }}
                          >
                            {col}
                          </td>
                          <td
                            style={{
                              padding: 3,
                              textAlign: 'right',
                              backgroundColor: isAvg ? '#f69696' : '#dfdcdc',
                              verticalAlign: 'top',
                            }}
                          >
                            {val}
                          </td>
                        </React.Fragment>
                      )
                    }

                    return (
                      <React.Fragment key={i}>
                        <td
                          style={{
                            padding: 3,
                            backgroundColor: col == null ? '#9e9c9c' : 'transparent',
                            verticalAlign: 'top',
                          }}
                        >
                          {col}
                        </td>

                        <td
                          style={{
                            padding: 3,
                            textAlign: 'right',
                            backgroundColor: val == null ? '#9e9c9c' : 'transparent',
                            verticalAlign: 'top',
                          }}
                        >
                          {val}
                        </td>
                      </React.Fragment>
                    )
                  })}
                </tr>
              )
            })}
          </table>
        </div>
      </>
    </Panel>
  )
}
